import React from 'react';
import CityCenterFlag from '@lt/components/icons-react/rebrand/CityCenterFlag';
import HotelFeature from '../HotelFeature';

import styles from './CityCenterDistanceFeature.module.css';
import { formatDistance } from './utils';

type CityCenterDistanceFeatureProps = {
  value: number | null;
  isMobile: boolean;
};

const CityCenterDistanceFeature: React.FC<CityCenterDistanceFeatureProps> = ({
  value,
  isMobile,
}) =>
  value ? (
    <HotelFeature
      Label={formatDistance(value)}
      Icon={<CityCenterFlag className={styles.iconCityDistance} />}
      isMobile={isMobile}
    />
  ) : null;

export default CityCenterDistanceFeature;
